'use client'
import {
  WbkContactUs_default
} from "./chunk-4CB2E3SW.mjs";
import {
  MIN_AGE_ALLOWED
} from "./chunk-ABL36LU5.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-IJKZ5OMO.mjs";

// src/ui/components/accessibility/AccessibilityButton.tsx
import { Button as Button5, Typography as Typography11 } from "@wbk/ui";
import { useRouter as useRouter3, useTranslation as useTranslation11 } from "@wbk/config";
import { twMerge as twMerge3 } from "tailwind-merge";
import { AccessibilityIcon as AccessibilityIcon3 } from "@wbk/svg";
import { useAuth as useAuth3 } from "@wbk/auth";
import { useGetAccessibilityRequests } from "@wbk/api/hooks";
import { useQueue } from "@wbk/queue";

// src/ui/components/accessibility/form/AccessibilityModal.tsx
import { useEffect as useEffect2, useRef, useState } from "react";
import { Button as Button4, ResponsiveModal as ResponsiveModal2, Toast, Typography as Typography10 } from "@wbk/ui";
import { useRouter as useRouter2, useTranslation as useTranslation10 } from "@wbk/config";
import { AuthForm, useAuth as useAuth2 } from "@wbk/auth";
import { parseDateString } from "@wbk/utils";
import { FormProvider, useForm } from "react-hook-form";
import {
  useCancelAccessibilityRequest,
  useCreateAccessibilityRequest,
  useUpdateAccessibilityRequest
} from "@wbk/api/hooks";
import { AnimatePresence, motion } from "motion/react";
import { useDeviceDetect } from "@wbk/hooks";

// src/ui/components/accessibility/details/AccessibilityDetails.tsx
import { Typography as Typography3 } from "@wbk/ui";
import { useTranslation as useTranslation3 } from "@wbk/config";

// src/ui/components/accessibility/details/StatusSection.tsx
import { useTranslation } from "@wbk/config";
import { Button, Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var StatusSection = ({ userAccessibility, onCancel, onResubmit, onUpdate, isPending }) => {
  const { t } = useTranslation("ticketing_accessibility");
  if (!userAccessibility) return null;
  const { status, reason } = userAccessibility;
  switch (status) {
    case "approved":
      return /* @__PURE__ */ jsx("div", { className: "space-y-1", children: /* @__PURE__ */ jsx(Typography, { color: "success", variant: "heading-M", children: t("ticketing_accessibility:status.approved") }) });
    case "pending":
      return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "heading-M", className: "text-blue-500", children: t("ticketing_accessibility:status.pending") }),
        /* @__PURE__ */ jsx(
          Button,
          {
            shape: "outlined",
            theme: "action",
            className: "border-paper-level-1 text-text w-full",
            onClick: onCancel,
            loading: isPending,
            children: /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", color: "text-primary", children: t("ticketing_accessibility:cancel_request") })
          }
        )
      ] });
    case "under_review":
      return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "heading-M", className: "text-blue-500", children: t("ticketing_accessibility:status.under_review") }),
        /* @__PURE__ */ jsx(
          Button,
          {
            shape: "outlined",
            theme: "action",
            className: "border-paper-level-1 text-text w-full",
            onClick: onCancel,
            loading: isPending,
            children: /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", color: "text-primary", children: t("ticketing_accessibility:cancel_request") })
          }
        )
      ] });
    case "rejected":
      return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
        reason && /* @__PURE__ */ jsx("div", { className: "bg-error-800 text-error-contrast rounded p-2", children: /* @__PURE__ */ jsx(Typography, { variant: "label-S", children: reason }) }),
        /* @__PURE__ */ jsx(Typography, { color: "error", variant: "heading-M", children: t("ticketing_accessibility:status.rejected") }),
        /* @__PURE__ */ jsx(Button, { theme: "action", className: "w-full", onClick: onResubmit, children: /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", children: t("ticketing_accessibility:submit_new_request") }) })
      ] });
    case "needs_update":
      return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
        reason && /* @__PURE__ */ jsx("div", { className: "bg-notice-700 text-error-contrast rounded p-2", children: /* @__PURE__ */ jsx(Typography, { variant: "label-S", children: reason }) }),
        /* @__PURE__ */ jsx(Typography, { color: "notice", variant: "heading-M", children: t("ticketing_accessibility:status.needs_update") }),
        /* @__PURE__ */ jsx(Button, { theme: "action", className: "w-full", onClick: onUpdate, children: /* @__PURE__ */ jsxs(Typography, { variant: "heading-XS", children: [
          " ",
          t("ticketing_accessibility:update_and_resend")
        ] }) })
      ] });
    case "expired":
      return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
        /* @__PURE__ */ jsx(Typography, { color: "error", variant: "heading-M", children: t("ticketing_accessibility:status.expired") }),
        /* @__PURE__ */ jsx(Button, { theme: "action", className: "w-full", onClick: onUpdate, children: /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", children: t("ticketing_accessibility:submit_new_request") }) })
      ] });
    case "cancelled":
      return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
        /* @__PURE__ */ jsx(Typography, { color: "text-secondary", variant: "heading-M", children: t("ticketing_accessibility:status.cancelled") }),
        /* @__PURE__ */ jsx(Button, { theme: "action", className: "w-full", onClick: onUpdate, children: /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", children: t("ticketing_accessibility:submit_new_request") }) })
      ] });
    default:
      return null;
  }
};
var StatusSection_default = StatusSection;

// src/ui/components/accessibility/details/DetailsSection.tsx
import { twMerge } from "tailwind-merge";
import { CopyButton, ImageWithFallback, Paper, Tooltip, Typography as Typography2 } from "@wbk/ui";
import { Link, useTranslation as useTranslation2 } from "@wbk/config";
import { ExclamationIcon } from "@wbk/svg";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var DetailsSection = ({ userAccessibility }) => {
  const { t } = useTranslation2(["ticketing_accessibility", "ticketing_common"]);
  if (!userAccessibility) return null;
  const fields = [
    {
      key: "request_number",
      label: t("ticketing_accessibility:form.request_number"),
      value: userAccessibility.request_number,
      copyable: true
    },
    {
      key: "disability_type",
      label: t("ticketing_accessibility:form.accessibility_type"),
      value: t(`ticketing_accessibility:form.${userAccessibility.disability_type}`)
    },
    {
      key: "need_companion",
      label: t("ticketing_accessibility:form.companion_ticket"),
      value: t(`ticketing_accessibility:form.companion_ticket_${userAccessibility.need_companion}`)
    },
    { key: "name", label: t("ticketing_accessibility:form.name"), value: userAccessibility.name },
    { key: "dob", label: t("ticketing_accessibility:form.dob"), value: userAccessibility.dob },
    {
      key: "nationality",
      label: t("ticketing_accessibility:form.nationality"),
      value: userAccessibility.nationality
    },
    {
      key: "national_id",
      label: t("ticketing_accessibility:form.national_id"),
      value: userAccessibility.national_id
    },
    { key: "email", label: t("ticketing_common:email"), value: userAccessibility.email },
    {
      key: "attachment",
      label: t("ticketing_accessibility:form.attachments"),
      value: "",
      attachment: userAccessibility.attachment
    }
  ];
  return /* @__PURE__ */ jsxs2("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx2(Paper, { className: "flex flex-col gap-2", children: fields.map(({ key, label, value, copyable, attachment }) => {
      var _a, _b;
      return /* @__PURE__ */ jsxs2(
        "div",
        {
          className: "border-paper-level-1 flex justify-between border-b pb-2 last:border-none last:pb-0",
          children: [
            /* @__PURE__ */ jsxs2("div", { className: "flex flex-col", children: [
              userAccessibility.status === "expired" && key === "attachment" ? /* @__PURE__ */ jsxs2(
                Typography2,
                {
                  variant: "label-M",
                  color: "error-400",
                  className: "flex items-center justify-between gap-1",
                  children: [
                    label,
                    /* @__PURE__ */ jsx2(
                      Tooltip,
                      {
                        side: "top",
                        defaultOpen: true,
                        content: /* @__PURE__ */ jsx2(Typography2, { variant: "label-M", color: "text-primary", className: "text-text", children: t("ticketing_accessibility:expired_card") }),
                        children: /* @__PURE__ */ jsx2(ExclamationIcon, { className: "h-4 w-4" })
                      }
                    )
                  ]
                }
              ) : /* @__PURE__ */ jsx2(Typography2, { variant: "label-M", children: label }),
              /* @__PURE__ */ jsx2(
                Typography2,
                {
                  variant: "body-S",
                  color: ((_a = userAccessibility == null ? void 0 : userAccessibility.fields_need_update) == null ? void 0 : _a.includes(key)) ? "error-400" : "text-secondary",
                  children: value
                }
              )
            ] }),
            copyable && /* @__PURE__ */ jsx2(CopyButton, { url: value.toString(), mini: true, className: "text-text" }),
            attachment && /* @__PURE__ */ jsx2(Link, { to: attachment, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx2(
              ImageWithFallback,
              {
                src: attachment,
                alt: "preview",
                className: twMerge(
                  "h-10 w-auto rounded border object-cover",
                  ((_b = userAccessibility == null ? void 0 : userAccessibility.fields_need_update) == null ? void 0 : _b.includes(key)) ? "border-error-400" : "border-paper-level-1"
                )
              }
            ) })
          ]
        },
        label
      );
    }) }),
    /* @__PURE__ */ jsx2(WbkContactUs_default, {})
  ] });
};
var DetailsSection_default = DetailsSection;

// src/ui/components/accessibility/details/AccessibilityDetails.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var AccessibilityDetails = ({
  userAccessibility,
  onCancel,
  onResubmit,
  onUpdate,
  isPending
}) => {
  const { t } = useTranslation3("ticketing_accessibility");
  return /* @__PURE__ */ jsxs3("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsx3(
      StatusSection_default,
      {
        userAccessibility,
        onCancel,
        onResubmit,
        onUpdate,
        isPending
      }
    ),
    /* @__PURE__ */ jsx3(Typography3, { variant: "heading-S", children: t("ticketing_accessibility:request_details") }),
    /* @__PURE__ */ jsx3(DetailsSection_default, { userAccessibility })
  ] });
};
var AccessibilityDetails_default = AccessibilityDetails;

// src/ui/components/accessibility/details/RequestStatus.tsx
import { useTranslation as useTranslation4 } from "@wbk/config";
import { Typography as Typography4 } from "@wbk/ui";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var RequestStatus = ({ status }) => {
  const { t } = useTranslation4("ticketing_accessibility");
  return /* @__PURE__ */ jsxs4("div", { className: "space-y-1", children: [
    /* @__PURE__ */ jsx4(Typography4, { variant: "heading-M", as: "h3", children: t(`ticketing_accessibility:request_status.${status}_title`) }),
    /* @__PURE__ */ jsx4(Typography4, { color: "text-secondary", children: t(`ticketing_accessibility:request_status.${status}_desc`) })
  ] });
};
var RequestStatus_default = RequestStatus;

// src/ui/components/accessibility/ExistingRequestView.tsx
import { AccessibilityIcon, ChevronIcon } from "@wbk/svg";
import { Button as Button2, Paper as Paper2, Typography as Typography6 } from "@wbk/ui";
import { useTranslation as useTranslation6 } from "@wbk/config";

// src/ui/components/accessibility/StatusBadge.tsx
import { useTranslation as useTranslation5 } from "@wbk/config";
import { Typography as Typography5 } from "@wbk/ui";
import { twMerge as twMerge2 } from "tailwind-merge";
import { jsx as jsx5 } from "react/jsx-runtime";
var STATUS_LABELS = {
  pending: "pending",
  under_review: "under_review",
  approved: "approved",
  rejected: "rejected",
  expired: "expired",
  cancelled: "cancelled",
  needs_update: "needs_update"
};
var STATUS_COLORS = {
  pending: "bg-blue-500",
  under_review: "bg-blue-500",
  approved: "bg-success-800",
  rejected: "bg-error-800",
  expired: "bg-error-800",
  cancelled: "bg-transparent",
  needs_update: "bg-notice"
};
var StatusBadge = ({ status }) => {
  const { t } = useTranslation5("ticketing_accessibility");
  if (!status) return null;
  return /* @__PURE__ */ jsx5(
    Typography5,
    {
      variant: "label-XS",
      className: twMerge2(
        "rounded px-2 py-1",
        STATUS_COLORS[status],
        status !== "cancelled" && "text-white"
      ),
      children: t(`ticketing_accessibility:status.${STATUS_LABELS[status]}`)
    }
  );
};
var StatusBadge_default = StatusBadge;

// src/ui/components/accessibility/ExistingRequestView.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var ExistingRequestView = (_a) => {
  var _b = _a, { open, status } = _b, paperProps = __objRest(_b, ["open", "status"]);
  const { t } = useTranslation6("ticketing_accessibility");
  return /* @__PURE__ */ jsx6(Paper2, __spreadProps(__spreadValues({ className: "!p-0" }, paperProps), { children: /* @__PURE__ */ jsxs5(
    Button2,
    {
      theme: "action",
      shape: "text",
      className: "!p-M flex w-full !items-center justify-start gap-4 text-start",
      onClick: open,
      children: [
        /* @__PURE__ */ jsx6(AccessibilityIcon, { className: "mt-0.5 h-5 w-5 object-contain" }),
        /* @__PURE__ */ jsx6(Typography6, { variant: "label-M", className: "grow", children: t("ticketing_accessibility:accessibility_card") }),
        /* @__PURE__ */ jsx6(StatusBadge_default, { status }),
        /* @__PURE__ */ jsx6(ChevronIcon, { className: "rtl:rotate-180" })
      ]
    }
  ) }));
};
var ExistingRequestView_default = ExistingRequestView;

// src/ui/components/accessibility/form/AccessibilityReview.tsx
import { useEffect, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox, ImageWithFallback as ImageWithFallback2, Paper as Paper3, Typography as Typography7 } from "@wbk/ui";
import { useAuth } from "@wbk/auth";
import { useTranslation as useTranslation7 } from "@wbk/config";
import { ExclamationIcon as ExclamationIcon2 } from "@wbk/svg";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var AccessibilityReview = () => {
  var _a, _b, _c;
  const { user } = useAuth();
  const { t } = useTranslation7(["ticketing_common", "ticketing_accessibility"]);
  const {
    getValues,
    control,
    watch,
    formState: { errors }
  } = useFormContext();
  const values = getValues();
  const attachment = watch("attachment");
  const attachmentUrl = useMemo(() => {
    if (!attachment) return "";
    return URL.createObjectURL(attachment);
  }, [attachment]);
  useEffect(() => {
    return () => {
      if (attachmentUrl) {
        URL.revokeObjectURL(attachmentUrl);
      }
    };
  }, [attachmentUrl]);
  return /* @__PURE__ */ jsxs6("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs6("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx7(Typography7, { variant: "heading-S", children: t("ticketing_accessibility:review_info") }),
      /* @__PURE__ */ jsx7(Typography7, { color: "text-secondary", children: t("ticketing_accessibility:review_info_desc") })
    ] }),
    /* @__PURE__ */ jsxs6(Paper3, { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx7(ReviewRow, { label: t("ticketing_accessibility:form.name"), value: values.name }),
      /* @__PURE__ */ jsx7(
        ReviewRow,
        {
          label: t("ticketing_accessibility:form.dob"),
          value: values.dob,
          error: (_a = errors.dob) == null ? void 0 : _a.message
        }
      ),
      /* @__PURE__ */ jsx7(
        ReviewRow,
        {
          label: t("ticketing_accessibility:form.nationality"),
          value: values.nationality
        }
      ),
      /* @__PURE__ */ jsx7(
        ReviewRow,
        {
          label: t("ticketing_accessibility:form.national_id"),
          value: values.national_id,
          error: (_b = errors.national_id) == null ? void 0 : _b.message
        }
      ),
      /* @__PURE__ */ jsx7(ReviewRow, { label: t("ticketing_common:email"), value: values.email || (user == null ? void 0 : user.email) || "" }),
      /* @__PURE__ */ jsx7(
        ReviewRow,
        {
          label: t("ticketing_accessibility:form.accessibility_type"),
          value: t(`ticketing_accessibility:form.${values.disability_type}`)
        }
      ),
      /* @__PURE__ */ jsx7(
        ReviewRow,
        {
          label: t("ticketing_accessibility:form.companion_ticket"),
          value: t(`ticketing_accessibility:form.companion_ticket_${values.need_companion}`)
        }
      ),
      attachment && /* @__PURE__ */ jsx7(
        ReviewRow,
        {
          label: "Attachments",
          value: /* @__PURE__ */ jsxs6("div", { className: "flex items-center justify-between gap-3", children: [
            /* @__PURE__ */ jsx7(Typography7, { children: attachment.name }),
            /* @__PURE__ */ jsx7(
              ImageWithFallback2,
              {
                src: attachmentUrl,
                className: "h-12 w-12 shrink-0 rounded-lg object-cover"
              }
            )
          ] }),
          error: (_c = errors.attachment) == null ? void 0 : _c.message
        }
      )
    ] }),
    /* @__PURE__ */ jsxs6(Paper3, { size: "M", className: "flex items-center gap-3 rounded-lg bg-blue-900/50", children: [
      /* @__PURE__ */ jsx7(ExclamationIcon2, { className: "h-5 w-5 shrink-0" }),
      /* @__PURE__ */ jsx7(Typography7, { variant: "body-S", color: "text-primary", className: "text-body-S leading-relaxed", children: t("ticketing_accessibility:subject_to_availability") })
    ] }),
    /* @__PURE__ */ jsx7(
      Controller,
      {
        name: "confirm_for_user",
        control,
        rules: {
          required: t("ticketing_accessibility:form.validation.confirm_for_user")
        },
        render: (_d) => {
          var _e = _d, { field: _f } = _e, _g = _f, { onChange, value } = _g, props = __objRest(_g, ["onChange", "value"]), { fieldState: { error } } = _e;
          return /* @__PURE__ */ jsx7(
            Checkbox,
            __spreadProps(__spreadValues({}, props), {
              checked: value || false,
              label: t("ticketing_accessibility:form.confirm_for_user"),
              id: "confirm_for_user",
              error: error == null ? void 0 : error.message,
              onChange,
              groupClassName: "px-1"
            })
          );
        }
      }
    )
  ] });
};
var ReviewRow = ({
  label,
  value,
  error
}) => /* @__PURE__ */ jsxs6("div", { className: "border-paper-level-1 flex flex-col border-b pb-2 last:border-none last:pb-0", children: [
  /* @__PURE__ */ jsx7(Typography7, { variant: "label-M", children: label }),
  /* @__PURE__ */ jsx7(Typography7, { variant: "body-S", as: "span", color: "text-secondary", children: value }),
  error && /* @__PURE__ */ jsx7(Typography7, { color: "error", variant: "body-XS", children: error })
] });

// src/ui/components/accessibility/form/AccessibilityForm.tsx
import { Controller as Controller2, useFormContext as useFormContext2 } from "react-hook-form";
import {
  Button as Button3,
  ImageWithFallback as ImageWithFallback3,
  Input,
  Paper as Paper4,
  RadioGroup,
  Select,
  Switch,
  Typography as Typography9
} from "@wbk/ui";
import { COUNTRIES, dateAdd } from "@wbk/utils";
import { Link as Link2, Trans, useRouter, useTranslation as useTranslation9 } from "@wbk/config";
import { AccessibilityIcon as AccessibilityIcon2, MultiplePersonIcon, WheelchairIcon } from "@wbk/svg";

// src/ui/components/accessibility/form/EligibilityModal.tsx
import { useTranslation as useTranslation8 } from "@wbk/config";
import { ExclamationIcon as ExclamationIcon3, OutlinedCheckIcon } from "@wbk/svg";
import { ResponsiveModal, Typography as Typography8 } from "@wbk/ui";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var EligibilityModal = () => {
  const { t } = useTranslation8("ticketing_accessibility");
  return /* @__PURE__ */ jsx8(
    ResponsiveModal,
    {
      surface: "default",
      title: /* @__PURE__ */ jsxs7("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx8("div", { children: t("ticketing_accessibility:form.eligibility_proof") }),
        /* @__PURE__ */ jsx8(Typography8, { color: "text-secondary", children: t("ticketing_accessibility:form.eligibility.subtitle") })
      ] }),
      action: false,
      size: "sm",
      cancel: {
        label: /* @__PURE__ */ jsx8(Typography8, { as: "span", variant: "heading-XS", children: t("ticketing_accessibility:form.eligibility.got_it") }),
        theme: "action",
        shape: "solid",
        className: "w-full"
      },
      render: ({ open }) => /* @__PURE__ */ jsx8(ExclamationIcon3, { className: "h-5 w-5", onClick: open }),
      body: () => /* @__PURE__ */ jsxs7("ul", { className: "space-y-2", children: [
        /* @__PURE__ */ jsxs7(Typography8, { as: "li", variant: "label-M", className: "flex items-center gap-2.5", children: [
          /* @__PURE__ */ jsx8(OutlinedCheckIcon, { className: "h-5 w-5 shrink-0" }),
          t("ticketing_accessibility:form.eligibility.note_1")
        ] }),
        /* @__PURE__ */ jsxs7(Typography8, { as: "li", variant: "label-M", className: "flex items-center gap-2.5", children: [
          /* @__PURE__ */ jsx8(OutlinedCheckIcon, { className: "h-5 w-5 shrink-0" }),
          t("ticketing_accessibility:form.eligibility.note_2")
        ] }),
        /* @__PURE__ */ jsxs7(Typography8, { as: "li", variant: "label-M", className: "flex items-center gap-2.5", children: [
          /* @__PURE__ */ jsx8(OutlinedCheckIcon, { className: "h-5 w-5 shrink-0" }),
          t("ticketing_accessibility:form.eligibility.note_3")
        ] })
      ] })
    }
  );
};
var EligibilityModal_default = EligibilityModal;

// src/ui/components/accessibility/form/AccessibilityForm.tsx
import { Fragment, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var AccessibilityForm = ({ onNext }) => {
  var _a, _b, _c;
  const { t } = useTranslation9(["ticketing_common", "ticketing_accessibility"]);
  const { locale } = useRouter();
  const {
    control,
    watch,
    formState: { errors },
    handleSubmit
  } = useFormContext2();
  const disabilityType = watch("disability_type");
  const maxDob = (_c = (_b = (_a = dateAdd({
    date: /* @__PURE__ */ new Date(),
    value: -MIN_AGE_ALLOWED,
    interval: "year"
  })) == null ? void 0 : _a.toISOString()) == null ? void 0 : _b.split("T")) == null ? void 0 : _c[0];
  return /* @__PURE__ */ jsx9(Fragment, { children: /* @__PURE__ */ jsxs8("form", { onSubmit: handleSubmit(onNext), id: "accessibility-form", className: "space-y-8", children: [
    /* @__PURE__ */ jsxs8("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx9(Typography9, { variant: "heading-S", children: t("ticketing_accessibility:form.title") }),
      /* @__PURE__ */ jsx9(
        Controller2,
        {
          name: "name",
          control,
          rules: { required: t("ticketing_accessibility:form.validation.name") },
          render: (_d) => {
            var _e = _d, { field: _f } = _e, _g = _f, { value = "", onChange } = _g, rest = __objRest(_g, ["value", "onChange"]), { fieldState: { error } } = _e;
            return /* @__PURE__ */ jsx9(
              Input,
              __spreadValues({
                label: t("ticketing_accessibility:form.name"),
                id: "name",
                value,
                onChange: (val) => onChange(val),
                error: error == null ? void 0 : error.message,
                hideErrorMark: true
              }, rest)
            );
          }
        }
      ),
      /* @__PURE__ */ jsx9(
        Controller2,
        {
          name: "dob",
          control,
          rules: { required: t("ticketing_accessibility:form.validation.dob") },
          render: (_h) => {
            var _i = _h, { field: _j } = _i, _k = _j, { value = "", onChange } = _k, rest = __objRest(_k, ["value", "onChange"]), { fieldState: { error } } = _i;
            return /* @__PURE__ */ jsx9(
              Input,
              __spreadValues({
                label: t("ticketing_accessibility:form.dob"),
                id: "dob",
                type: "date",
                value,
                max: maxDob,
                pattern: "\\d{4}-\\d{2}-\\d{2}",
                onChange: (val) => onChange(val),
                error: error == null ? void 0 : error.message,
                hideErrorMark: true
              }, rest)
            );
          }
        }
      ),
      /* @__PURE__ */ jsx9(
        Controller2,
        {
          name: "nationality",
          control,
          rules: { required: t("ticketing_common:validation.required") },
          defaultValue: "",
          render: (_l) => {
            var { field: _m } = _l, _n = _m, { onChange, value } = _n, rest = __objRest(_n, ["onChange", "value"]);
            var _a2;
            return /* @__PURE__ */ jsx9(
              Select,
              __spreadProps(__spreadValues({}, rest), {
                id: "nationality",
                value,
                autoComplete: "off",
                portal: false,
                label: t("ticketing_accessibility:form.nationality"),
                hideErrorMark: true,
                onChange: (selected) => onChange((selected == null ? void 0 : selected.value) || ""),
                options: COUNTRIES.map((c) => ({
                  id: c.code,
                  value: c.code,
                  text: c.name[locale] || c.name.en,
                  icon: /* @__PURE__ */ jsx9(
                    "img",
                    {
                      className: "shrink-0",
                      src: `https://wbk-assets-backup.s3.eu-west-1.amazonaws.com/flags/w80/${c.code.toLowerCase()}.png`,
                      width: 20,
                      height: 14,
                      alt: c.name.en
                    }
                  )
                })),
                error: (_a2 = errors.nationality) == null ? void 0 : _a2.message
              })
            );
          }
        }
      ),
      /* @__PURE__ */ jsx9(
        Controller2,
        {
          name: "national_id",
          control,
          rules: { required: t("ticketing_accessibility:form.validation.national_id") },
          render: (_o) => {
            var _p = _o, { field: _q } = _p, _r = _q, { value = "", onChange } = _r, rest = __objRest(_r, ["value", "onChange"]), { fieldState: { error } } = _p;
            return /* @__PURE__ */ jsx9(
              Input,
              __spreadValues({
                label: t("ticketing_accessibility:form.national_id"),
                id: "national_id",
                value,
                onChange: (val) => onChange(val),
                error: error == null ? void 0 : error.message,
                hideErrorMark: true
              }, rest)
            );
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs8("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx9(Typography9, { variant: "heading-S", children: t("ticketing_accessibility:form.accessibility_type") }),
      /* @__PURE__ */ jsx9(
        Controller2,
        {
          name: "disability_type",
          control,
          rules: {
            required: t("ticketing_accessibility:form.validation.accessibility_type")
          },
          render: ({ field }) => {
            var _a2;
            return /* @__PURE__ */ jsx9(
              RadioGroup,
              __spreadProps(__spreadValues({
                label: "",
                theme: "action",
                indicator: "check",
                options: [
                  {
                    text: /* @__PURE__ */ jsxs8("div", { className: "flex items-center gap-3", children: [
                      /* @__PURE__ */ jsx9(AccessibilityIcon2, { className: "h-6 w-6 shrink-0" }),
                      /* @__PURE__ */ jsxs8("div", { children: [
                        /* @__PURE__ */ jsx9(Typography9, { variant: "label-M", children: t("ticketing_accessibility:form.easy_access") }),
                        /* @__PURE__ */ jsx9(Typography9, { variant: "body-S", color: "text-secondary", children: t("ticketing_accessibility:form.easy_access_desc") })
                      ] })
                    ] }),
                    value: "easy_access"
                  },
                  {
                    text: /* @__PURE__ */ jsxs8("div", { className: "flex items-center gap-3", children: [
                      /* @__PURE__ */ jsx9(WheelchairIcon, { className: "h-6 w-6 shrink-0" }),
                      /* @__PURE__ */ jsxs8("div", { children: [
                        /* @__PURE__ */ jsx9(Typography9, { variant: "label-M", children: t("ticketing_accessibility:form.wheel_chair") }),
                        /* @__PURE__ */ jsx9(Typography9, { variant: "body-S", color: "text-secondary", children: t("ticketing_accessibility:form.wheel_chair_desc") })
                      ] })
                    ] }),
                    value: "wheel_chair"
                  }
                ]
              }, field), {
                error: (_a2 = errors.disability_type) == null ? void 0 : _a2.message
              })
            );
          }
        }
      ),
      disabilityType === "wheel_chair" && /* @__PURE__ */ jsx9(
        Controller2,
        {
          name: "need_companion",
          shouldUnregister: disabilityType !== "wheel_chair",
          control,
          render: ({ field: { value, onChange }, fieldState: { error } }) => /* @__PURE__ */ jsxs8(Paper4, { className: "p-M", children: [
            /* @__PURE__ */ jsxs8(
              Typography9,
              {
                as: "label",
                className: "flex cursor-pointer items-center justify-between gap-3 rounded-xl",
                children: [
                  /* @__PURE__ */ jsxs8("div", { className: "flex items-center gap-3", children: [
                    /* @__PURE__ */ jsx9(MultiplePersonIcon, { className: "h-6 w-6 shrink-0" }),
                    /* @__PURE__ */ jsx9(Typography9, { variant: "label-M", children: t("ticketing_accessibility:form.companion_ticket") })
                  ] }),
                  /* @__PURE__ */ jsx9(
                    Switch,
                    {
                      checked: value,
                      onChange: (checked) => onChange(checked),
                      hideErrorSpace: true,
                      groupClassName: "ltr:ml-auto rtl:mr-auto"
                    }
                  )
                ]
              }
            ),
            error && /* @__PURE__ */ jsx9(Typography9, { variant: "body-XS", color: "error", children: error.message })
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs8("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsxs8("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx9(Typography9, { variant: "heading-S", children: t("ticketing_accessibility:form.eligibility_proof") }),
        /* @__PURE__ */ jsx9(EligibilityModal_default, {})
      ] }),
      /* @__PURE__ */ jsx9(
        Controller2,
        {
          name: "attachment",
          control,
          rules: { required: t("ticketing_accessibility:form.validation.attachment") },
          render: (_s) => {
            var _t = _s, { field: _u } = _t, _v = _u, { onChange, value } = _v, field = __objRest(_v, ["onChange", "value"]), { fieldState: { error } } = _t;
            return /* @__PURE__ */ jsxs8("div", { className: "space-y-3", children: [
              /* @__PURE__ */ jsx9(
                Button3,
                {
                  theme: "action",
                  shape: "text",
                  className: "!p-M border-paper justify-start gap-2 border",
                  onClick: (e) => {
                    var _a2;
                    e.preventDefault();
                    (_a2 = document.getElementById("accessibility-upload")) == null ? void 0 : _a2.click();
                  },
                  children: /* @__PURE__ */ jsx9(Typography9, { variant: "heading-XS", color: "text-primary", className: "text-text", children: t("ticketing_accessibility:form.disability_certificate") })
                }
              ),
              /* @__PURE__ */ jsx9(
                "input",
                __spreadProps(__spreadValues({
                  id: "accessibility-upload",
                  type: "file",
                  accept: "image/png,image/jpg,image/jpeg,application/pdf",
                  className: "hidden"
                }, field), {
                  onChange: (e) => {
                    var _a2;
                    const file = (_a2 = e.target.files) == null ? void 0 : _a2[0];
                    if (file) onChange(file);
                  }
                })
              ),
              value && /* @__PURE__ */ jsxs8(Paper4, { className: "p-S flex items-center justify-between", children: [
                /* @__PURE__ */ jsx9(Typography9, { children: value == null ? void 0 : value.name }),
                /* @__PURE__ */ jsx9(
                  ImageWithFallback3,
                  {
                    src: URL.createObjectURL(value),
                    alt: "preview",
                    className: "h-10 w-10 rounded object-cover"
                  }
                )
              ] }),
              error && /* @__PURE__ */ jsx9(Typography9, { variant: "body-XS", color: "error", children: error.message })
            ] });
          }
        }
      ),
      /* @__PURE__ */ jsxs8("ul", { className: "text-text-secondary ms-4 list-disc text-sm", children: [
        /* @__PURE__ */ jsx9("li", { children: t("ticketing_accessibility:form.eligibility_proof_note_1") }),
        /* @__PURE__ */ jsx9("li", { children: t("ticketing_accessibility:form.eligibility_proof_note_2") })
      ] }),
      /* @__PURE__ */ jsx9(Paper4, { size: "M", surface: "level-1", border: false, children: /* @__PURE__ */ jsx9(
        Typography9,
        {
          variant: "body-S",
          color: "text-primary",
          className: "text-body-S leading-relaxed",
          children: /* @__PURE__ */ jsx9(Trans, { i18nKey: "ticketing_accessibility:review_process_notice", children: /* @__PURE__ */ jsx9(
            Button3,
            {
              theme: "transparent",
              shape: "text",
              className: "p-0 underline",
              as: Link2,
              href: `/${locale}/privacy`,
              target: "_blank",
              rel: "noreferrer"
            }
          ) })
        }
      ) })
    ] })
  ] }) });
};
var AccessibilityForm_default = AccessibilityForm;

// src/ui/components/accessibility/form/AccessibilityModal.tsx
import { Fragment as Fragment2, jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var defaultValues = {
  name: "",
  dob: "",
  nationality: "",
  national_id: "",
  disability_type: "easy_access",
  need_companion: false,
  attachment: void 0,
  confirm_for_user: false
};
var AccessibilityModal = ({
  userAccessibility,
  isLoading,
  render,
  hasInfo,
  onLoginSuccess,
  slug,
  sourceType
}) => {
  const { search } = useRouter2();
  const { user } = useAuth2();
  const { t } = useTranslation10(["ticketing_accessibility", "ticketing_common"]);
  const modalRef = useRef(null);
  const [step, setStep] = useState();
  const [isReady, setIsReady] = useState(false);
  const { isWebView } = useDeviceDetect();
  const toast = useRef(void 0);
  const methods = useForm({
    defaultValues: __spreadProps(__spreadValues({}, defaultValues), {
      name: (user == null ? void 0 : user.name) || "",
      email: user == null ? void 0 : user.email,
      dob: parseDateString(user == null ? void 0 : user.dob),
      nationality: (user == null ? void 0 : user.nationality) || ""
    })
  });
  const {
    mutateAsync: createRequest,
    isPending: isCreatePending,
    error: createError
  } = useCreateAccessibilityRequest();
  const {
    mutateAsync: updateRequest,
    isPending: isUpdatePending,
    error: updateError
  } = useUpdateAccessibilityRequest();
  const {
    mutateAsync: cancelRequest,
    isPending: isCancelPending,
    error: cancelError
  } = useCancelAccessibilityRequest();
  const isPending = isCreatePending || isUpdatePending || isCancelPending;
  const errorMessage = (createError == null ? void 0 : createError.message) || (updateError == null ? void 0 : updateError.message) || (cancelError == null ? void 0 : cancelError.message);
  const handleWebViewSubmit = (res) => {
    var _a, _b;
    if (!isWebView) return;
    (_a = window.ReactNativeWebView) == null ? void 0 : _a.postMessage(
      JSON.stringify({
        eventName: "USER_UPDATE_INFO",
        data: {
          accessibility_profile: {
            _id: res._id,
            status: res.status,
            expiry_date: null,
            disability_type: res.disability_type
          }
        }
      })
    );
    (_b = window.ReactNativeWebView) == null ? void 0 : _b.postMessage(JSON.stringify({ eventName: "CLOSE_WEBVIEW" }));
  };
  const handleSubmitCreate = (_0) => __async(null, [_0], function* ({
    close,
    values
  }) {
    var _a;
    try {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        if (value === null || value === void 0) return;
        if (value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, String(value));
        }
      });
      if (slug) {
        formData.append("slug", slug);
      }
      if (sourceType) {
        formData.append("source_type", sourceType);
      }
      let res = null;
      if (userAccessibility) {
        res = yield updateRequest({ id: userAccessibility._id, body: formData });
      } else {
        res = yield createRequest({ body: formData });
      }
      close == null ? void 0 : close();
      handleWebViewSubmit(res);
      if (!isWebView) {
        (_a = toast.current) == null ? void 0 : _a.publish({
          title: t("ticketing_accessibility:form.request_sent"),
          icon: true
        });
      }
      methods.reset(defaultValues);
    } catch (err) {
      Object.entries(err.errors || {}).map(([key, value]) => {
        methods.setError(key, { message: value.join(",") });
      });
    }
  });
  const handleCancel = (_0) => __async(null, [_0], function* ({ close }) {
    if (!userAccessibility) return;
    try {
      const res = yield cancelRequest({ id: userAccessibility._id });
      close == null ? void 0 : close();
      if (isWebView) {
        handleWebViewSubmit(res);
      }
      setStep("create");
    } catch (err) {
    }
  });
  useEffect2(() => {
    var _a;
    if (search.get("accessibility") === "true") {
      if (isWebView) {
        setStep("create");
      }
      (_a = modalRef.current) == null ? void 0 : _a.open();
    }
  }, [search, isWebView]);
  useEffect2(() => {
    var _a, _b;
    if (!isLoading) {
      setStep(userAccessibility ? hasInfo ? "info" : "details" : "create");
      setIsReady(true);
      methods.reset(__spreadProps(__spreadValues({}, defaultValues), {
        name: (userAccessibility == null ? void 0 : userAccessibility.name) || (user == null ? void 0 : user.name) || "",
        email: (userAccessibility == null ? void 0 : userAccessibility.email) || (user == null ? void 0 : user.email),
        dob: parseDateString((userAccessibility == null ? void 0 : userAccessibility.dob) || (user == null ? void 0 : user.dob)),
        nationality: (userAccessibility == null ? void 0 : userAccessibility.nationality) || (user == null ? void 0 : user.nationality) || "",
        disability_type: (_a = userAccessibility == null ? void 0 : userAccessibility.disability_type) != null ? _a : defaultValues.disability_type,
        need_companion: (_b = userAccessibility == null ? void 0 : userAccessibility.need_companion) != null ? _b : defaultValues.need_companion
      }));
    }
  }, [userAccessibility, hasInfo, isLoading]);
  return /* @__PURE__ */ jsxs9(Fragment2, { children: [
    /* @__PURE__ */ jsx10(Toast, { ref: toast }),
    /* @__PURE__ */ jsx10(
      ResponsiveModal2,
      {
        dismissible: isWebView ? false : true,
        size: "lg",
        onClose: () => setStep(userAccessibility ? hasInfo ? "info" : "details" : "create"),
        closeButton: isWebView ? false : void 0,
        surface: "default",
        action: !user ? false : step === "review" ? {
          label: t("ticketing_accessibility:submit_request"),
          loading: isPending,
          theme: "primary",
          onClick: () => methods.handleSubmit((values) => {
            handleSubmitCreate({
              close: () => {
                var _a;
                setStep("details");
                (_a = modalRef.current) == null ? void 0 : _a.close();
              },
              values
            });
          })()
        } : step === "create" || step === "update" ? {
          type: "submit",
          theme: "action",
          form: "accessibility-form",
          className: isWebView ? "w-full" : "",
          label: t("ticketing_accessibility:form.next_confirm")
        } : false,
        cancel: !user ? false : step === "review" || (step === "create" || step === "update") && !isWebView ? {
          label: step === "review" ? t("ticketing_common:back") : t("ticketing_common:cancel"),
          theme: "action",
          shape: "text",
          disabled: step === "review" && isPending,
          onClick: ({ close }) => step === "create" ? close() : setStep(step === "review" ? "create" : "details")
        } : false,
        ref: modalRef,
        ignoreHistory: true,
        title: user ? step === "info" ? t("ticketing_accessibility:request_status.title") : t("ticketing_accessibility:title") : null,
        render: ({ open }) => render ? render({ open }) : /* @__PURE__ */ jsx10(Button4, { theme: "action", onClick: open, children: /* @__PURE__ */ jsx10(Typography10, { variant: "body-L", className: "font-semibold", children: t("ticketing_accessibility:apply_now") }) }),
        body: ({ close }) => !user ? /* @__PURE__ */ jsx10(
          AuthForm,
          {
            className: "m-0 border-none !p-0",
            onSuccess: (user2) => {
              var _a, _b;
              if (((_a = user2.accessibility_profile) == null ? void 0 : _a.status) === "approved") {
                (_b = modalRef.current) == null ? void 0 : _b.close();
              }
              onLoginSuccess == null ? void 0 : onLoginSuccess(user2);
            }
          }
        ) : isLoading || !isReady ? /* @__PURE__ */ jsx10(LoadingSkeleton, { shortSkeleton: hasInfo }) : /* @__PURE__ */ jsx10(FormProvider, __spreadProps(__spreadValues({}, methods), { children: /* @__PURE__ */ jsx10("div", { className: "relative overflow-hidden", children: /* @__PURE__ */ jsx10(AnimatePresence, { initial: false, custom: step, mode: "wait", children: /* @__PURE__ */ jsxs9(
          motion.div,
          {
            custom: step,
            variants: {
              enter: (direction) => ({
                x: direction === "review" ? "100%" : "-100%",
                opacity: 0
              }),
              center: { x: 0, opacity: 1 },
              exit: (direction) => ({
                x: direction === "create" ? "100%" : "-100%",
                opacity: 0
              })
            },
            initial: "enter",
            animate: "center",
            exit: "exit",
            transition: { duration: 0.25 },
            children: [
              step === "info" && userAccessibility ? /* @__PURE__ */ jsxs9("div", { className: "space-y-4", children: [
                /* @__PURE__ */ jsx10(RequestStatus_default, { status: userAccessibility.status }),
                /* @__PURE__ */ jsx10(
                  ExistingRequestView_default,
                  {
                    open: () => setStep("details"),
                    status: userAccessibility.status,
                    surface: "level-1"
                  }
                )
              ] }) : step === "review" ? /* @__PURE__ */ jsx10(AccessibilityReview, {}) : step === "details" && userAccessibility ? /* @__PURE__ */ jsx10(
                AccessibilityDetails_default,
                {
                  userAccessibility,
                  onCancel: () => {
                    handleCancel({ close });
                  },
                  onResubmit: () => setStep("create"),
                  onUpdate: () => setStep("update"),
                  isPending
                }
              ) : /* @__PURE__ */ jsx10(AccessibilityForm_default, { onNext: () => setStep("review") }),
              errorMessage && /* @__PURE__ */ jsx10(Typography10, { color: "error", children: errorMessage })
            ]
          },
          step
        ) }) }) }))
      }
    )
  ] });
};
var AccessibilityModal_default = AccessibilityModal;
var LoadingSkeleton = ({ shortSkeleton }) => {
  return /* @__PURE__ */ jsxs9("div", { className: "space-y-6 p-6", children: [
    /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-8 w-3/4 animate-pulse rounded" }),
    /* @__PURE__ */ jsxs9("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-12 w-full animate-pulse rounded" }),
      !shortSkeleton && /* @__PURE__ */ jsxs9(Fragment2, { children: [
        /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-12 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-12 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-12 w-full animate-pulse rounded" })
      ] })
    ] }),
    !shortSkeleton && /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-32 w-full animate-pulse rounded" }),
    /* @__PURE__ */ jsxs9("div", { className: "flex justify-end gap-4", children: [
      /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-10 w-24 animate-pulse rounded" }),
      /* @__PURE__ */ jsx10("div", { className: "bg-paper-level-2 h-10 w-24 animate-pulse rounded" })
    ] })
  ] });
};

// src/ui/components/accessibility/AccessibilityButton.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var AccessibilityButton = (_a) => {
  var _b = _a, { slug, className, render, type } = _b, props = __objRest(_b, ["slug", "className", "render", "type"]);
  const { user } = useAuth3();
  const { isActive } = useQueue();
  const { push, locale } = useRouter3();
  const { t } = useTranslation11("ticketing_event");
  const { data: userAccessibility, isLoading } = useGetAccessibilityRequests(
    { lang: locale },
    { enabled: !!user }
  );
  const REDIRECT_URL = `/${locale}/${type}/${slug}/accessibility`;
  const isApproved = (userAccessibility == null ? void 0 : userAccessibility.status) === "approved";
  const handleAccessibility = ({ open }) => {
    if (isApproved) {
      push(REDIRECT_URL);
    } else {
      open();
    }
  };
  if (isActive) return null;
  return /* @__PURE__ */ jsx11(
    AccessibilityModal_default,
    {
      isLoading,
      userAccessibility,
      hasInfo: true,
      slug,
      sourceType: type === "events" ? "event" : "season",
      onLoginSuccess: (user2) => {
        var _a2;
        if (((_a2 = user2.accessibility_profile) == null ? void 0 : _a2.status) === "approved") {
          push(REDIRECT_URL);
        }
      },
      render: ({ open }) => render ? render({
        open: () => handleAccessibility({ open }),
        isApproved,
        isLoading: !!isLoading
      }) : /* @__PURE__ */ jsxs10(
        Button5,
        __spreadProps(__spreadValues({
          onClick: () => handleAccessibility({ open }),
          theme: "action",
          shape: "soft",
          className: twMerge3("mx-auto min-h-12 w-full justify-center gap-2 lg:mx-0", className)
        }, props), {
          children: [
            /* @__PURE__ */ jsx11(AccessibilityIcon3, { className: "h-5 w-5 shrink-0" }),
            /* @__PURE__ */ jsx11(Typography11, { variant: "body-L", strong: true, as: "span", children: t("ticketing_event:accessibility.get_tickets") })
          ]
        })
      )
    }
  );
};
var AccessibilityButton_default = AccessibilityButton;

export {
  ExistingRequestView_default,
  AccessibilityModal_default,
  AccessibilityButton_default
};
//# sourceMappingURL=chunk-PKM42LJ3.mjs.map